import { imprimir } from '@/utils/RelatorioHTML'
import QRCode from 'qrcode'

function numero(valor) {
  if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0
  if (valor === null || typeof valor === 'undefined') return 0

  const texto = String(valor).replace(/[^\d,.-]/g, '')
  if (!texto) return 0

  if (texto.indexOf(',') >= 0 && texto.indexOf('.') >= 0) {
    return Number(texto.replace(/\./g, '').replace(',', '.')) || 0
  }
  if (texto.indexOf(',') >= 0) return Number(texto.replace(',', '.')) || 0
  return Number(texto) || 0
}

function moeda(valor) {
  return numero(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function peso(valor) {
  return numero(valor).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
}

function inteiro(valor) {
  return numero(valor).toLocaleString('pt-BR', { maximumFractionDigits: 0 })
}

function texto(valor) {
  return String(valor === null || typeof valor === 'undefined' ? '' : valor)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function data(valor) {
  if (!valor) return ''
  const dt = new Date(valor)
  if (Number.isNaN(dt.getTime())) return texto(valor)
  return dt.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
}

function totalItem(item) {
  const totalPrevisto = numero(item.VL_TOTAL_PREVISTO)
  if (totalPrevisto > 0) return totalPrevisto
  return numero(item.QUANT_PEDIDO) * numero(item.VL_UNT)
}

function formaPagamento(cab) {
  if (cab.OP_FORMA_PAGTO === 'V') return 'A VISTA'
  if (cab.OP_FORMA_PAGTO === 'P') return 'A PRAZO'
  return cab.FORMA || cab.PAG2 || cab.PRAZO || ''
}

function campo(label, val, sm = false) {
  if (!val && val !== 0) return ''
  return `<div class="frow">
    <span class="flabel">${label}:</span>
    <span class="fval${sm ? ' fval-sm' : ''}">${texto(val)}</span>
  </div>`
}

function buildStyles() {
  return `<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 8pt;
    color: #1a1a1a;
    background: #fff;
    padding: 4mm;
  }
  @media print {
    @page { size: A4 portrait; margin: 10mm 15mm; }
    body { padding: 0; }
  }
  .doc-header {
    display: grid;
    grid-template-columns: 1fr auto;
    border: 2px solid #1a3a5c;
    margin-bottom: 3px;
  }
  .empresa-block {
    padding: 8px 10px;
    display: flex;
    align-items: center;
  }
  .empresa-info .nome {
    font-size: 10pt;
    font-weight: bold;
    color: #1a3a5c;
    line-height: 1.2;
  }
  .empresa-info .razao {
    font-size: 7.5pt;
    color: #444;
  }
  .empresa-info .detalhe {
    font-size: 7pt;
    color: #666;
    margin-top: 1px;
  }
  .doc-side {
    border-left: 2px solid #1a3a5c;
    background: #f0f5f9;
    padding: 7px 14px;
    min-width: 165px;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .doc-titulo {
    font-size: 12pt;
    font-weight: bold;
    letter-spacing: 2px;
    color: #1a3a5c;
    line-height: 1;
  }
  .doc-subtitulo {
    font-size: 7pt;
    color: #666;
    letter-spacing: 0.8px;
    margin-bottom: 2px;
    text-transform: uppercase;
  }
  .doc-numero {
    font-size: 20pt;
    font-weight: bold;
    color: #1a3a5c;
    line-height: 1.05;
  }
  .doc-ctrl, .doc-data { font-size: 7pt; color: #555; }
  .doc-situacao {
    display: inline-block;
    margin-top: 4px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 6.5pt;
    font-weight: bold;
    background: #d97706;
    color: #fff;
    text-transform: uppercase;
  }
  .sec-label {
    background: #1a3a5c;
    color: #fff;
    padding: 2px 8px;
    font-size: 7.5pt;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
  .ident-block {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .ident-col { padding: 5px 8px; }
  .ident-col:first-child { border-right: 1px solid #b0bec5; }
  .frow {
    display: flex;
    align-items: baseline;
    margin-bottom: 2px;
    line-height: 1.35;
  }
  .flabel {
    color: #666;
    font-size: 7pt;
    min-width: 78px;
    flex-shrink: 0;
  }
  .fval {
    font-size: 8pt;
    font-weight: 600;
    flex: 1;
    word-break: break-word;
  }
  .fval-sm { font-size: 7pt; font-weight: 500; }
  .summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .summary-box {
    padding: 6px 8px;
    text-align: center;
  }
  .summary-box + .summary-box { border-left: 1px solid #b0bec5; }
  .summary-label {
    font-size: 7pt;
    color: #666;
    font-weight: bold;
    text-transform: uppercase;
  }
  .summary-value {
    display: block;
    font-size: 12pt;
    font-weight: bold;
    color: #1a3a5c;
  }
  table.items {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 3px;
  }
  table.items th {
    background: #1a3a5c;
    color: #fff;
    padding: 3px 4px;
    border: 1px solid #8ba7bf;
    text-align: center;
    font-size: 7pt;
    white-space: nowrap;
  }
  table.items td {
    border: 1px solid #cfd8dc;
    padding: 2px 4px;
    vertical-align: middle;
    font-size: 7.5pt;
  }
  table.items tbody tr:nth-child(even) td { background: #fafbfc; }
  table.items tfoot td {
    background: #e8f0f5;
    border: 1px solid #b0bec5;
    padding: 2px 4px;
    font-weight: bold;
  }
  .r { text-align: right; }
  .c { text-align: center; }
  .bottom-section {
    display: grid;
    grid-template-columns: 2fr 1.1fr 1.5fr;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .bot-box { padding: 5px 8px; }
  .bot-box + .bot-box { border-left: 1px solid #b0bec5; }
  .obs-text {
    font-size: 7.5pt;
    color: #333;
    white-space: pre-wrap;
    word-break: break-word;
  }
  .fin-row, .tot-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
    font-size: 7.5pt;
  }
  .fin-label, .tot-label { color: #666; font-size: 7pt; }
  .fin-val, .tot-val { font-weight: 600; text-align: right; }
  .tot-grand {
    border-top: 2px solid #1a3a5c;
    margin-top: 5px;
    padding-top: 3px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    font-size: 9pt;
    color: #1a3a5c;
  }
  .validacao-section {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
    padding: 8px 10px;
    background: #f8fafc;
  }
  .qr-img { flex-shrink: 0; }
  .qr-info { font-size: 8pt; color: #333; line-height: 1.8; }
  .qr-info strong { color: #1a3a5c; }
  .qr-hint { font-size: 7pt; color: #888; font-style: italic; margin-top: 4px; }
  .assinatura-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .assin-box {
    padding: 4px 12px 8px;
    text-align: center;
  }
  .assin-box + .assin-box { border-left: 1px solid #b0bec5; }
  .assin-line {
    border-top: 1px solid #333;
    margin: 22px auto 4px;
    width: 85%;
  }
  .assin-label { font-size: 7.5pt; font-weight: bold; color: #1a3a5c; }
  .assin-sub { font-size: 6.5pt; color: #666; margin-top: 2px; }
  .doc-footer {
    border-top: 1px solid #b0bec5;
    padding-top: 4px;
    display: flex;
    justify-content: space-between;
    font-size: 6.5pt;
    color: #888;
    margin-top: 3px;
  }
  .doc-footer strong { color: #1a3a5c; }
</style>`
}

function buildCompanyHeader(cab) {
  const nomeEmpresa = cab.FANTASIA || cab.TX_RAZAO_SOCIAL || ''
  const mostrarRazao = cab.FANTASIA && cab.TX_RAZAO_SOCIAL && cab.FANTASIA !== cab.TX_RAZAO_SOCIAL

  return `<div class="doc-header">
  <div class="empresa-block">
    <div class="empresa-info">
      <div class="nome">${texto(nomeEmpresa)}</div>
      ${mostrarRazao ? `<div class="razao">${texto(cab.TX_RAZAO_SOCIAL)}</div>` : ''}
      ${cab.ENDERECO_EMPRESA ? `<div class="detalhe">${texto(cab.ENDERECO_EMPRESA)}</div>` : ''}
      <div class="detalhe">
        ${cab.CNPJ_EMPRESA ? 'CNPJ: ' + texto(cab.CNPJ_EMPRESA) : ''}
        ${cab.IE_EMPRESA ? ' | IE: ' + texto(cab.IE_EMPRESA) : ''}
        ${cab.TX_TELEFONE_EMPRESA ? ' | Fone: ' + texto(cab.TX_TELEFONE_EMPRESA) : ''}
      </div>
    </div>
  </div>
  <div class="doc-side">
    <div class="doc-subtitulo">Pedido de Venda</div>
    <div class="doc-titulo">ESTIMADO</div>
    <div class="doc-numero">${texto(String(cab.N_VENDA || cab.SEQUENCIA || ''))}</div>
    <div class="doc-ctrl">Controle: ${texto(cab.SEQUENCIA)}</div>
    <div class="doc-data">${cab.DT_PEDIDO ? 'Data: <b>' + data(cab.DT_PEDIDO) + '</b>' : ''}</div>
    <div><span class="doc-situacao">${texto(cab.SITUACAO_TRADUZIDO || 'ESTIMADO')}</span></div>
  </div>
</div>`
}

function buildIdentBlock(cab) {
  const endCli = [
    cab.ENDERECO_CLI,
    cab.NUMERO_CLI ? 'No ' + cab.NUMERO_CLI : null,
    cab.COMPLEMENTO
  ].filter(Boolean).join(', ')
  const cidUf = [cab.NOME_MUNICIPIO, cab.ID_UF].filter(Boolean).join(' - ')

  return `<div class="sec-label">Identificacao e Endereco</div>
<div class="ident-block">
  <div class="ident-col">
    ${campo('Cliente', cab.NOME || cab.RAZAOSOCIAL)}
    ${campo('Razao Social', cab.RAZAOSOCIAL, true)}
    ${campo('CNPJ/CPF', cab.CGC)}
    ${campo('IE', cab.INS_EST)}
    ${campo('Endereco', endCli)}
    ${campo('Bairro', cab.BAIRRO_CLI)}
    ${campo('Cidade/UF', cidUf, true)}
    ${campo('CEP', cab.CEP)}
    ${campo('Telefone', cab.TELEFONE)}
  </div>
  <div class="ident-col">
    ${campo('Entrega/Rota', cab.NENTREGA)}
    ${campo('Forma Pgto', formaPagamento(cab))}
    ${campo('Motorista', cab.NOME_MOTORISTA)}
    ${campo('Vendedor', cab.NOME_VENDEDOR)}
    ${campo('Data Pedido', data(cab.DT_PEDIDO))}
    ${campo('Prev. Entrega', data(cab.DT_PREVISAO_ENTREGA))}
    ${campo('Obs Pedido', cab.OBS_PEDIDO, true)}
  </div>
</div>`
}

function buildSummary(cab, itens) {
  const totalPrevisto = numero(cab.VL_TOTAL_PREVISTO) || itens.reduce((soma, item) => soma + totalItem(item), 0)
  const quantPrevista = numero(cab.QUANT_PEDIDO) || itens.reduce((soma, item) => soma + numero(item.QUANT_PEDIDO), 0)
  const pecasPrevistas = itens.reduce((soma, item) => soma + numero(item.PECAS_PEDIDO), 0)

  return `<div class="sec-label">Resumo Previsto</div>
<div class="summary">
  <div class="summary-box"><span class="summary-label">Pecas previstas</span><span class="summary-value">${inteiro(pecasPrevistas)}</span></div>
  <div class="summary-box"><span class="summary-label">Quantidade prevista</span><span class="summary-value">${peso(quantPrevista)} kg</span></div>
  <div class="summary-box"><span class="summary-label">Total previsto</span><span class="summary-value">R$ ${moeda(totalPrevisto)}</span></div>
</div>`
}

function buildItemsTable(itens) {
  const totalPecas = itens.reduce((soma, item) => soma + numero(item.PECAS_PEDIDO), 0)
  const totalQuant = itens.reduce((soma, item) => soma + numero(item.QUANT_PEDIDO), 0)
  const totalGeral = itens.reduce((soma, item) => soma + totalItem(item), 0)

  const rows = itens.map(item => `<tr>
    <td class="c">${texto(item.COD_PRO)}</td>
    <td>${texto(item.NOME_PRODUTO)}</td>
    <td class="r">${inteiro(item.PECAS_PEDIDO)}</td>
    <td class="r">${peso(item.QUANT_PEDIDO)}</td>
    <td class="c">${texto(item.TX_UNIDADE_COMERCIAL || item.UND_ENT || '')}</td>
    <td class="r">${moeda(item.VL_UNT)}</td>
    <td class="r">${moeda(totalItem(item))}</td>
  </tr>`).join('')

  return `<table class="items">
  <thead>
    <tr>
      <th>Codigo</th>
      <th>Descricao</th>
      <th>PCS</th>
      <th>Quant. Prev.</th>
      <th>UND</th>
      <th>Preco</th>
      <th>Total Previsto</th>
    </tr>
  </thead>
  <tbody>${rows}</tbody>
  <tfoot>
    <tr>
      <td colspan="2">Total de ${itens.length} item(ns)</td>
      <td class="r">${inteiro(totalPecas)}</td>
      <td class="r">${peso(totalQuant)}</td>
      <td colspan="2"></td>
      <td class="r">R$ ${moeda(totalGeral)}</td>
    </tr>
  </tfoot>
</table>`
}

function buildBottom(cab, itens) {
  const obs = [cab.OBSERVACOES, cab.OBS3].filter(Boolean).join('\n')
  const totalItens = itens.reduce((soma, item) => soma + totalItem(item), 0)
  const totalPrevisto = numero(cab.VL_TOTAL_PREVISTO) || totalItens

  return `<div class="sec-label" style="display:grid;grid-template-columns:2fr 1.1fr 1.5fr;">
  <span>Observacoes</span><span>Financeiro</span><span>Totalizadores</span>
</div>
<div class="bottom-section">
  <div class="bot-box"><div class="obs-text">${texto(obs)}</div></div>
  <div class="bot-box">
    <div class="fin-row"><span class="fin-label">Forma Pgto:</span><span class="fin-val">${texto(formaPagamento(cab))}</span></div>
    ${cab.NR_PARCELAS ? `<div class="fin-row"><span class="fin-label">Parcelas:</span><span class="fin-val">${texto(cab.NR_PARCELAS)}x</span></div>` : ''}
    ${cab.PRAZO ? `<div class="fin-row"><span class="fin-label">Prazo (dias):</span><span class="fin-val">${texto(cab.PRAZO)}</span></div>` : ''}
    ${cab.DT_INICIAR_PAGAMENTO ? `<div class="fin-row"><span class="fin-label">Inicio Pgto:</span><span class="fin-val">${data(cab.DT_INICIAR_PAGAMENTO)}</span></div>` : ''}
    ${cab.DT_PAG ? `<div class="fin-row"><span class="fin-label">Vencimento:</span><span class="fin-val">${data(cab.DT_PAG)}</span></div>` : ''}
  </div>
  <div class="bot-box">
    <div class="tot-row"><span class="tot-label">Produtos previstos:</span><span class="tot-val">R$ ${moeda(totalItens)}</span></div>
    ${cab.VL_TOTAL_DESCONTO ? `<div class="tot-row"><span class="tot-label">Desconto:</span><span class="tot-val">- R$ ${moeda(cab.VL_TOTAL_DESCONTO)}</span></div>` : ''}
    ${cab.VL_TOTAL_FRETE ? `<div class="tot-row"><span class="tot-label">Frete:</span><span class="tot-val">R$ ${moeda(cab.VL_TOTAL_FRETE)}</span></div>` : ''}
    <div class="tot-grand"><span>TOTAL PREVISTO:</span><span>R$ ${moeda(totalPrevisto)}</span></div>
  </div>
</div>`
}

function buildValidacao(qrDataUrl, cab) {
  const infoLines = [
    `<strong>Pedido estimado No ${texto(String(cab.N_VENDA || cab.SEQUENCIA || ''))}</strong> - Controle: ${texto(String(cab.SEQUENCIA || ''))}`,
    `Emissao: ${cab.DT_PEDIDO ? data(cab.DT_PEDIDO) : ''}`,
    `Empresa: ${texto(cab.FANTASIA || cab.TX_RAZAO_SOCIAL || '')}`,
    `Cliente: ${texto(cab.NOME || cab.RAZAOSOCIAL || '')}`,
    `CNPJ/CPF: ${texto(cab.CGC || '')}`,
    `Quantidade prevista: <strong>${peso(cab.QUANT_PEDIDO)} kg</strong>`,
    `Total previsto: <strong>R$ ${moeda(cab.VL_TOTAL_PREVISTO)}</strong>`
  ].join('<br>')

  const qrHtml = qrDataUrl ? `<div class="qr-img"><img src="${qrDataUrl}" width="90" height="90" alt="QR Code" /></div>` : ''

  return `<div class="sec-label">Validacao do Documento</div>
<div class="validacao-section">
  ${qrHtml}
  <div>
    <div class="qr-info">${infoLines}</div>
    <div class="qr-hint">Escaneie o QR Code para conferir os dados estimados deste pedido.</div>
  </div>
</div>`
}

function buildAssinaturas() {
  return `<div class="assinatura-section">
  <div class="assin-box">
    <div class="assin-line"></div>
    <div class="assin-label">Assinatura do Cliente</div>
    <div class="assin-sub">Nome / CPF / RG</div>
  </div>
  <div class="assin-box">
    <div class="assin-line"></div>
    <div class="assin-label">Assinatura do Entregador</div>
    <div class="assin-sub">Nome / CPF</div>
  </div>
  <div class="assin-box">
    <div class="assin-line"></div>
    <div class="assin-label">Ciente / Conferencia</div>
    <div class="assin-sub">Data: ____/____/____</div>
  </div>
</div>`
}

function buildFooter() {
  return `<div class="doc-footer">
  <span><strong>CEC Frigo</strong> - Sistema de Controle e Gestao</span>
  <span>Documento estimado. Pesos e valores finais podem mudar apos a pesagem.</span>
  <span>Impresso: ${new Date().toLocaleString('pt-BR')}</span>
</div>`
}

export async function imprimirPedidoEstimado($http, vendaId) {
  await $http.post(`/api/protected/vendapedido/recalcularPrevisao/${vendaId}`)

  const response = await $http.get(`/api/protected/vendapedido/getPedidoEstimadoData/${vendaId}`)
  const { cabecalho: cab, itens } = response.data
  const listaItens = Array.isArray(itens) ? itens : []

  const qrText = [
    `PEDIDO ESTIMADO: ${cab.N_VENDA || cab.SEQUENCIA || ''}`,
    `CONTROLE: ${cab.SEQUENCIA || ''}`,
    `EMISSAO: ${cab.DT_PEDIDO ? data(cab.DT_PEDIDO) : ''}`,
    `EMPRESA: ${cab.FANTASIA || cab.TX_RAZAO_SOCIAL || ''}`,
    `CLIENTE: ${cab.NOME || cab.RAZAOSOCIAL || ''}`,
    `CNPJ/CPF: ${cab.CGC || ''}`,
    `QUANTIDADE PREVISTA: ${peso(cab.QUANT_PEDIDO)} KG`,
    `TOTAL PREVISTO: R$ ${moeda(cab.VL_TOTAL_PREVISTO)}`
  ].join('\n')

  let qrDataUrl = ''
  try {
    qrDataUrl = await QRCode.toDataURL(qrText, { width: 120, margin: 1, errorCorrectionLevel: 'M' })
  } catch (e) {
    console.error('Erro ao gerar QR Code:', e)
  }

  const titulo = `Pedido_Estimado_${cab.N_VENDA || cab.SEQUENCIA}`
  const html = `<!doctype html>
<html>
<head>
  <meta charset="utf-8">
  <title>${texto(titulo)}</title>
  ${buildStyles()}
</head>
<body>
  ${buildCompanyHeader(cab)}
  ${buildIdentBlock(cab)}
  ${buildSummary(cab, listaItens)}
  ${buildItemsTable(listaItens)}
  ${buildBottom(cab, listaItens)}
  ${buildValidacao(qrDataUrl, cab)}
  ${buildAssinaturas()}
  ${buildFooter()}
</body>
</html>`

  imprimir(html, titulo, 'A4', 'portrait')
  return true
}

export default imprimirPedidoEstimado



// WEBPACK FOOTER //
// ./src/views/movimentos/pedidovenda/PedidoEstimadoHTML.js